import apiService from "../../../../services/api";

export const getTalentMarketPlaceViewContactDetails = async (
  candidateId: string,
  payload: any,
) => {
  return apiService.post(`/candidates/${candidateId}/view-contact`, payload);
};
export const getTalentMarketPlaceSendMessage = async (jobSeekerId: string,payload: any) => {
  return apiService.post(`/candidates/${jobSeekerId}/message`, payload);
};
//api/v1/candidates/{job_seeker_id}/message
//  "subject": "string",
//   "message": "vcvfbfg",
//   "access_type": "marketplace",